import { TableBody, TableRow } from "@material-ui/core";
import { useContext } from "react";
import { LocalContext } from "../../LocalProvider";
import { StyledTableCell, StyledTableRow, useStyles } from "./Wishlist.styles";
import { WishlistContext } from "./WishlistContext";
import WishlistDetails from "./WishlistDetails";
import NoRecord from "../common/NoRecord.component";

const WishlistList = () => {
  const { wishlistDataProvider, clearWishList } = useContext(WishlistContext);
  const { translate } = useContext(LocalContext);
  const classes = useStyles();
  return wishlistDataProvider.length ? (
    <TableBody>
      {wishlistDataProvider.length !== 0 &&
        wishlistDataProvider.map((row, key) => {
          return <WishlistDetails wishlistDataProvider={row} key={key} />;
        })}
    </TableBody>
  ) : (
    <TableBody>
      <StyledTableRow>
        <StyledTableCell
          component="th"
          scope="row"
          colSpan="6"
        >
          <NoRecord message={translate("No Records Found!")} />
        </StyledTableCell>
      </StyledTableRow>        
    </TableBody>
  );
};

export default WishlistList;
